var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDollarJobInfo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50311 14.6685C4.8212 14.6685 1.83643 11.6838 1.83643 8.00185C1.83643 4.31997 4.8212 1.33521 8.50311 1.33521C12.185 1.33521 15.1698 4.31997 15.1698 8.00185C15.1698 11.6838 12.185 14.6685 8.50311 14.6685ZM8.50311 13.3352C11.4486 13.3352 13.8364 10.9474 13.8364 8.00185C13.8364 5.05635 11.4486 2.66854 8.50311 2.66854C5.55757 2.66854 3.16976 5.05635 3.16976 8.00185C3.16976 10.9474 5.55757 13.3352 8.50311 13.3352ZM6.16976 9.33519H9.83644C10.0205 9.33519 10.1698 9.18599 10.1698 9.00185C10.1698 8.81779 10.0205 8.66852 9.83644 8.66852H7.16977C6.24929 8.66852 5.50309 7.92232 5.50309 7.00185C5.50309 6.0814 6.24929 5.33521 7.16977 5.33521H7.83644V4.00187H9.16977V5.33521H10.8364V6.66852H7.16977C6.98567 6.66852 6.83643 6.81779 6.83643 7.00185C6.83643 7.18599 6.98567 7.33519 7.16977 7.33519H9.83644C10.7569 7.33519 11.5031 8.08139 11.5031 9.00185C11.5031 9.92232 10.7569 10.6685 9.83644 10.6685H9.16977V12.0019H7.83644V10.6685H6.16976V9.33519Z",
    fill: "#A3A3A3"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDollarJobInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dollar_job_info.9acba15d.svg";
export { ForwardRef as ReactComponent };